export const privacy = {
    header: {
        badge: "Données personnelles",
        title: "Politique de confidentialité"
    },
    content: {
        intro: "La protection de votre vie privée et de vos données personnelles est une priorité absolue pour DONKEY TRAVEL. Cette politique détaille la façon dont nous collectons, traitons et sécurisons vos informations.",
        collection: {
            title: "1. Collecte des données",
            text: "Nous collectons uniquement les données strictement nécessaires au bon fonctionnement de la plateforme : vos informations de création de compte (nom, prénom, e-mail), les liens vers vos annonces publiques (Airbnb), et vos préférences et disponibilités de voyage. Les mots de passe sont cryptés et les données de paiement sont traitées par notre partenaire sécurisé Stripe."
        },
        usage: {
            title: "2. Utilisation de vos données",
            text: "Vos informations sont utilisées pour: \n- Vérifier votre éligibilité (note de 4,5+) \n- Gérer votre abonnement \n- Faciliter la mise en relation avec d'autres membres \n- Fournir des recommandations personnalisées via notre Matching Intelligent \n- Améliorer nos services et résoudre les problèmes techniques."
        },
        sharing: {
            title: "3. Partage d'informations",
            text: "Nous ne vendrons JAMAIS vos données personnelles à des tiers. Leur partage est strictement limité à des fins opérationnelles avec nos prestataires de confiance (hébergement web, outil de paiement). En dehors de ce cadre, vos données ne sont partagées qu'entre membres pour l'organisation d'un échange (et seulement l'adresse exacte après validation d'un échange)."
        },
        security: {
            title: "4. Sécurité",
            text: "Les protocoles d'authentification et de sécurité les plus robustes sont mis en place pour protéger vos données contre l'accès non autorisé, l'altération, la divulgation ou la destruction."
        },
        rights: {
            title: "5. Vos droits (RGPD)",
            text: "Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, de portabilité ou de suppression de vos données personnelles à tout moment. Vous pouvez exercer ce droit depuis les paramètres de votre compte ou en nous écrivant à dpo@donkey.travel."
        },
        cookies: {
            title: "6. Cookies",
            text: "Nous utilisons des cookies essentiels pour maintenir votre session de connexion, ainsi que des cookies analytiques anonymes pour comprendre comment notre site est utilisé et améliorer votre expérience."
        }
    }
};
